import React from 'react';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import { formatCurrency } from '../../../client/lib/utils';
import CollectionStore from '../../stores/CollectionStore';
import InventoryRecordStore from '../../stores/InventoryRecordStore';
import RouteStore from '../../stores/RouteStore';
import InventoryRecordActions from '../../actions/InventoryRecordActions';
import Helmet from 'react-helmet';
import Breadcrumbs from '../../components/Breadcrumbs';
import InventoryRecordDetail from '../../components/InventoryRecordDetail';
import styles from '../BaseContainer/index.sass';

class InventoryRecordContainer extends React.Component {
  static contextTypes = {
    executeAction: React.PropTypes.func
  };

  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  componentDidMount() {
    let id = this.props.currentRoute.params.id;
    this.context.executeAction(InventoryRecordActions.fetchSimilar, {id});
  }

  getHelmetProps(store, inventoryRecord) {
    let description = inventoryRecord.description;
    if (!description) {
      let wineType = null;
      let wineRegion = null;
      let wineProducer = null;
      for (let i = 0; i < inventoryRecord.attributes.length; i++) {
        let attr = inventoryRecord.attributes[i].object;
        if (attr.header == 'Type') {
          wineType = attr.text;
        } else if (attr.header == 'Region') {
          wineRegion = attr.text;
        } else if (attr.header == 'Producer') {
          wineProducer = attr.text;
        }
      }
      description = '';
      if (wineType) {
        description += wineType;
      }
      if (wineRegion) {
        description += ' from ' + wineRegion;
      }
      if (wineProducer) {
        description += ' by ' + wineProducer + '. ';
      }
      description += 'Shop for wine and see reviews from Delectable users and Wine professionals on Banquet.';
    }
    let title = `${inventoryRecord.brand} ${inventoryRecord.name} – ${store.name}`;
    let helmetProps = {
      title: title,
      meta: [
        {name: 'description', content: description},
        {property: 'og:title', content: title},
        {property: 'og:description', content: description},
        {property: 'og:url', content: this.props.currentRoute.absolute_url},
        {name: 'twitter:card', content: 'summary_large_image'},
        {name: 'twitter:title', content: title},
        {name: 'twitter:description', content: description}
      ]
    };

    let photo = inventoryRecord.photo_hash.getChildByWidth(640);
    let photoUrl;
    if(photo && photo.width && photo.height) {
      photoUrl = photo.url;
      helmetProps.meta.push({property: 'og:image:width', content: photo.width});
      helmetProps.meta.push({property: 'og:image:height', content: photo.height});
    } else {
      photoUrl = inventoryRecord.photo_hash.getClosestToTarget(640);
    }
    helmetProps.meta.push({property: 'og:image', content: photoUrl});
    helmetProps.meta.push({name: 'twitter:image', content: photoUrl});
    return helmetProps;
  }

  render() {
    let { currentRoute, prevRoute, customer, collection, inventoryRecord, shoppingCart, store, similarProductCategories, similarProductCategoriesRequestStatus } = this.props;
    if(!inventoryRecord) {return null;}
    let inventoryRecordDetailProps = {
      store,
      collection,
      customer,
      inventoryRecord,
      currentRoute,
      similarProductCategories,
      similarProductCategoriesRequestStatus
    };
    let breadcrumbsProps = {
      links: []
    };

    if(currentRoute.params.collectionSlug && collection) {
      breadcrumbsProps.links.push({routeName: 'collections'});
      breadcrumbsProps.links.push({text: collection.title, routeName: 'collection', navParams: {slug: collection.slug}});
    } else if(prevRoute && prevRoute.name === 'search') {
      breadcrumbsProps.links.push({routeName: 'storeLandingPage'});
      let { filters } = prevRoute.query;
      if(filters && filters.length) {
        filters = filters.map((f) => {
          switch(f.type) {
            case 'min_price_in_cents':
              return `Over ${formatCurrency(f.value, {withoutTrailingZeros: true})}`;
            case 'max_price_in_cents':
              return `Under ${formatCurrency(f.value, {withoutTrailingZeros: true})}`;
            default:
              return f.value;
          }
        });
        breadcrumbsProps.links.push({text: `“${filters.join(' ')}”`, href: prevRoute.url});
      }
    } else {
      // TODO: add /products breadcrumb
      breadcrumbsProps.links.push({routeName: 'storeLandingPage'});
    }

    return (
      <section className={styles.container}>
        <Helmet {...this.getHelmetProps(store, inventoryRecord)} />
        <Breadcrumbs {...breadcrumbsProps} />
        <InventoryRecordDetail {...inventoryRecordDetailProps} />
      </section>
    );
  }
}

InventoryRecordContainer = connectToStores(InventoryRecordContainer, [CollectionStore, InventoryRecordStore], (context, props) => {
  let { collectionSlug, id, storeSlug } = props.currentRoute.params;
  let inventoryRecordStore = context.getStore(InventoryRecordStore);
  let prevRoute = context.getStore(RouteStore).getPreviousRoute();
  return {
    collection: context.getStore(CollectionStore).getEntityBySlug(collectionSlug),
    inventoryRecord: inventoryRecordStore.getEntityById(id),
    prevRoute: prevRoute
  };
});

export default InventoryRecordContainer;



// WEBPACK FOOTER //
// banquet/containers/InventoryRecordContainer/index.js